import { render, staticRenderFns } from "./incident-details.vue?vue&type=template&id=df1b6da2&"
import script from "./incident-details.vue?vue&type=script&lang=js&"
export * from "./incident-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports